import { type DealInsightsFilterOptionKeys, dealInsightsFilterOptionKeys } from '@openx/types/dealInsights';
import type { TFunction } from 'i18next';

export const getMoreFiltersLabel = (t: TFunction, key: DealInsightsFilterOptionKeys) => {
  switch (key) {
    case dealInsightsFilterOptionKeys.BUYER_NAME:
      return t('Buyer Name');
    case dealInsightsFilterOptionKeys.DSP_NAME:
      return t('DSP Name');
    case dealInsightsFilterOptionKeys.PUB_NAME:
      return t('Publisher Name');
    case dealInsightsFilterOptionKeys.TYPE_NAME:
      return t('Device');
    case dealInsightsFilterOptionKeys.DOMAIN_BUNDLE:
      return t('Domain/Bundle');
    case dealInsightsFilterOptionKeys.MEDIA_SUBTYPE:
      return t('Format');
    case dealInsightsFilterOptionKeys.CHANNEL:
      return t('Channel');
    case dealInsightsFilterOptionKeys.ADSIZE:
      return t('Ad Size');
    case dealInsightsFilterOptionKeys.AD_DURATION:
      return t('Ad Duration');
  }
};
